import { parseCssStyles } from './parse-styles';
export default (function (styles) {
  return function (theme) {
    return parseCssStyles(styles, null, theme);
  };
});